import React, { useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../../../../../msalConfig";
import _ from "lodash";
import ValidationMetrics from "./ValidationMetrics";
import { TELEMETRY_API } from "../../../../../../../constants/serverConfig";

const ValidationOverview = (props) => {
  const objectId = props.vdata;

  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.graphMe.scopes,
    account: account,
  };

  const VALID_SUB_API = `${TELEMETRY_API}metrics/quality?object_id=${objectId}&metric_flag=column`;

  const getvalidationmetricsdata = () => {
    setIsFetching(true);
    axios.get(VALID_SUB_API).then((res) => {

      let maindata = res.data;

      let filteriddata = _.filter(
        maindata["metrics"],
        (iddata) => iddata.objectId === `${objectId}`
      );
      let validmetricsdata = _.map(filteriddata, (da) => {
        return {
          metricValue: da.metricValue,
          metricKey: da.metricKey,
        };
      });
      setData(validmetricsdata);
      setIsFetching(false);
    });
  };

  useEffect(() => {
    const fetchdatasets = async () => {
      try {
        const token = (await instance.acquireTokenSilent(request)).accessToken;
        getvalidationmetricsdata(token);
      } catch (error) {
        if (error) {
          try {
            const token = (await instance.acquireTokenRedirect(request))
              .accessToken;
            getvalidationmetricsdata(token);
          } catch (error) {
            console.log(error)
          }
        }
      }
    };
    fetchdatasets();
  }, [instance]);

  return (
    <>
      {" "}
      <div className="justify-content-md-center">
        <ValidationMetrics data={data} fetching={isFetching} />
      </div>
    </>
  );
};

export default ValidationOverview;
